import Cookies from 'https://esm.archive.org/js-cookie';

// eslint-disable-next-line import/no-named-as-default
import $ from '../util/jquery.js';
import log from '../util/log.js';

function cookies_enabled() {
  try {
    // In sandboxed iframes, document.cookie throws an error.
    // eslint-disable-next-line no-unused-expressions
    document.cookie;
    return true;
  } catch (e) {
    return false;
  }
}

function initialize_flag() {
  const clearOverlay = () => {
    $('#theatre-ia-wrap').removeClass('flagged');
    $('.bookreader-playlist-container').removeClass('hide');
  };

  // overlay related
  $('.toggle-flag-overlay').on('click', (e) => {
    e.preventDefault();
    clearOverlay();
  });

  // overlay - checkboxes
  $('#flag-checkboxes a').on('click', function checkboxes_a_click(e) {
    e.preventDefault();
    $(this).children('.my-checkbox').toggleClass('checked');
    $.get($(this).attr('href'));
    clearOverlay();
  });

  if (cookies_enabled() && Cookies.get('logged-in-user') !== undefined) {
    $('#flag-popover li').on('click', function popover_li_click() {
      $(this).find('a').trigger('click');
      return false;
    });

    $('#flag-popover a').on('click', function popover_a_click(e) {
      e.preventDefault();
      const $flagPopup = $('#item-flags-popup');
      // optimistic update
      const $selection = $(this);
      const $selectedLine = $($selection).parent();
      $($selectedLine).toggleClass('selected');
      $($flagPopup).removeClass('open');

      $.getJSON(`${$(this).attr('href')}&no_chrome=1`, (data) => {
        const $newFlagPopup = $(data.button);
        $($flagPopup).replaceWith($newFlagPopup);

        $('#flag-button-container').html(data.button);
        $('#flag-overlay').html(data.overlay);
        if (data.has_flags) {
          $('#theatre-ia-wrap').addClass('flagged');
        } else {
          $('#theatre-ia-wrap').removeClass('flagged');
        }
        initialize_flag();
      });
      return false;
    });
  }
}
$(document).ready(() => {
  log('initialize item flags');
  initialize_flag();
});
